import React from "react";

import { toast } from "react-toastify";

import AuxInfoApi from "../api/auxInfoApi";

import { useQueryParams } from "../common/queryParams";
import { useSettings } from "../common/withSettings";
import Tracking from "../common/tracking";

import SettingsContext from "../contexts/settingsContext";

import Home from "../apps/home";
import PlayerLoginApp from "../apps/login/playerLoginApp";
import AdminApp from "../apps/admin/adminApp";
import CourtAlertsApp from "../apps/court-alerts/courtAlertsApp";
import FindOpponentApp from "../apps/find-opponent/findOpponentApp";
import TournamentApp from "../apps/tournament/tournamentApp";
import UmpireCastApp from "../apps/umpire-cast/umpireCastApp";
import ClubStreamApp from "../apps/club-stream/clubStreamApp";
import { isAdmin, isAuthenticated } from "../common/auth";
import SetScoreApp from "../apps/set-score/setScoreApp";
import ProcessingModal from "../common/processingModal";
import Offline from "../apps/offline";
import WrappedApp from "../apps/wrapped/wrappedApp";
import RallyRecordApp from "../apps/rally-record/rallyRecordApp";

class AtsRouter extends React.Component {
  state = {
    settings: {
      siteWhitelabel: "default",
      courtAlertsEnabled: false,
      findOpponentEnabled: false,
      tournamentsEnabled: false,
      umpireCastEnabled: false,
      clubStreamEnabled: false,
      rallyRecordEnabled: false,
      siteGtag: "",
      defaultApp: "Home",
    },
    settingsLoaded: false,
    isOffline: false,
  };

  async componentDidMount() {
    const { success, data: instanceSettings, message } = await AuxInfoApi.getInstanceSettings();

    if (!success) {
      this.setState({ isOffline: true, settingsLoaded: false });
      toast.error(message);
      return;
    }

    this.setState({ settings: instanceSettings, settingsLoaded: true });
  }

  render() {
    const { settings, settingsLoaded, isOffline } = this.state;

    return (
      <SettingsContext.Provider value={settings}>
        <GetApp settingsLoaded={settingsLoaded} isOffline={isOffline} />
      </SettingsContext.Provider>
    );
  }
}

function GetApp(props) {
  const queryParams = useQueryParams();
  const settings = useSettings();

  Tracking.initialize(settings.siteGtag);
  Tracking.pageView();

  if (props.isOffline) return <Offline />;
  if (!props.settingsLoaded) return <ProcessingModal text="Loading application..." />;

  if (settings.defaultApp === "rally-record") return <RallyRecordApp />;

  if ("signin" in queryParams) return <PlayerLoginApp />;

  if ("app" in queryParams) {
    if (isAdmin() && queryParams.app === "admin") return <AdminApp />;
    if (settings.courtAlertsEnabled && queryParams.app === "court-alerts") return isAuthenticated() ? <CourtAlertsApp /> : <PlayerLoginApp />;
    if (settings.findOpponentEnabled && queryParams.app === "find-opponent") return isAuthenticated() ? <FindOpponentApp /> : <PlayerLoginApp />;
    if (settings.tournamentsEnabled && queryParams.app === "tournament") return <TournamentApp />;
    if (settings.umpireCastEnabled && queryParams.app === "umpire-cast") return <UmpireCastApp />;
    if (settings.clubStreamEnabled && queryParams.app === "club-stream") return <ClubStreamApp />;
    if (queryParams.app === "set-score") return <SetScoreApp />;
    if (queryParams.app === "wrapped") return <WrappedApp />;
  }

  return <Home />;
}

export default AtsRouter;
